<template>
  <span class="svg-ico-play-triangle">
    <svg v-if="isTwoTone" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3109 3.69547C7.92765 2.37986 5.0957 4.14594 5.0957 6.79869V17.2023C5.0957 19.8439 7.92617 21.6224 10.3114 20.3053L15.2296 17.5969L19.7651 15.1082C22.2059 13.7612 22.2059 10.2398 19.7651 8.89285L10.3109 3.69547Z" :fill="color"/>
    </svg>
    <svg v-else-if="isSolid" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3109 3.69547C7.92765 2.37986 5.0957 4.14594 5.0957 6.79869V17.2023C5.0957 19.8439 7.92617 21.6224 10.3114 20.3053L15.2296 17.5969L19.7651 15.1082C22.2059 13.7612 22.2059 10.2398 19.7651 8.89285L10.3109 3.69547Z" :fill="color"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.60156 20.7004C8.00156 20.7004 7.40156 20.5004 6.80156 20.2004C5.70156 19.6004 5.10156 18.4004 5.10156 17.1004V6.80037C5.10156 5.50037 5.80156 4.4004 6.80156 3.7004C7.90156 3.1004 9.20156 3.00036 10.3016 3.60036L19.8016 8.80037C21.0016 9.40037 21.6016 10.6003 21.6016 11.9003C21.6016 13.2003 20.9016 14.4004 19.8016 15.0004L10.3016 20.2004C9.80156 20.6004 9.20156 20.7004 8.60156 20.7004ZM8.60156 4.7004C8.30156 4.7004 7.90156 4.80038 7.60156 5.00038C7.00156 5.40038 6.60156 6.00037 6.60156 6.80037V17.2004C6.60156 17.9004 7.00156 18.6004 7.60156 19.0004C8.20156 19.4004 9.00156 19.4004 9.60156 19.0004L19.1016 13.8004C19.8016 13.4004 20.2016 12.8004 20.2016 12.0004C20.2016 11.2004 19.8016 10.6004 19.1016 10.2004L9.60156 5.00038C9.30156 4.80038 8.90156 4.7004 8.60156 4.7004Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 28 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
